import { useIntl } from '@common/i18n';
import { useLogin } from '@common/uaa';
import { Box, Button, Flex, Image, Raio, Text } from '@common/ui-components';
import { useRouter } from 'next/router';

import { uaaIntlIds } from '../../intl';

export default function SignIn() {
  const { formatMessage } = useIntl();
  const router = useRouter();

  const signIn = useLogin({
    onSuccess: () => {
      router?.push('/');
    },
  });

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      w="100vw"
      h="100vh"
      bg="gray.100"
    >
      <Flex
        direction="column"
        align="center"
        justify="center"
        w="24rem"
        h="16.5rem"
        gap={6}
        bg="white"
        borderRadius={8}
        zIndex={1}
      >
        <Raio />

        <Text fontSize="lg" fontWeight="700" lineHeight={7}>
          {formatMessage({ id: uaaIntlIds.signIn.welcomeMessage })}
        </Text>

        <Text>
          {formatMessage({ id: uaaIntlIds.signIn.signInInstruction })}
        </Text>

        <Button onClick={() => signIn()}>
          {formatMessage({ id: uaaIntlIds.signIn.button.label })}
        </Button>
      </Flex>

      <Box position="fixed" bottom={12} right={8}>
        <Image
          src={'/images/man-riding-bike.svg'}
          alt={formatMessage({ id: uaaIntlIds.signIn.manRidingBikeAlt })}
          boxSize={{ base: '240px', lg: '240px', sm: '180px' }}
        />
      </Box>

      <Box
        position="fixed"
        w="calc(100vw - 32px)"
        bottom={8}
        right={0}
        borderTop="4px"
        borderLeftRadius={8}
        color="#1759FF"
      />
    </Flex>
  );
}
